function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Handler from "./handler";
import { I18n } from "zengular-util";
import User from "./user";
/**
 * @property {I18n} i18n
 * @property {User} user
 * @property {string} authApi
 */

var Magic = /*#__PURE__*/function () {
  function Magic() {
    _classCallCheck(this, Magic);

    _defineProperty(this, "event", {
      menuHandlerSelected: 'menuHandlerSelected',
      addNewItem: 'add-new-item',
      selectItem: 'select-item',
      search: 'search',
      unauthorized: 'unauthorized',
      activateForm: 'activate-form',
      itemChanged: 'item-changed',
      save: 'save'
    });

    this.handlers = {};
    this.user = null;
    this.i18n = new I18n({});
  }
  /**
   * @param name
   * @returns {Handler}
   */


  _createClass(Magic, [{
    key: "getHandler",
    value: function getHandler(name) {
      return this.handlers[name];
    }
    /**
     * @param {Handler} handler
     */

  }, {
    key: "addHandler",
    value: function addHandler(handler) {
      this.handlers[handler.name] = handler;
    }
  }, {
    key: "init",
    value: function init(authApi) {
      var _this = this;

      this.authApi = authApi;
      return fetch(authApi).then(function (res) {
        if (res.status === 200) return res.json();else throw 'unauthorized';
      }).then(function (user) {
        return _this.user = new User(user.id, user.name, user.avatar, user.roles);
      }).catch(function () {});
    }
  }]);

  return Magic;
}();

var magic = new Magic();
export default magic;